import React from 'react';
import useCopyToClipboard from 'react-use/esm/useCopyToClipboard';
import { capitalize } from 'lodash';
import { WarningPanel, CodeSnippet } from '@backstage/core-components';
import { useEntityList, useStarredEntities } from '@backstage/plugin-catalog-react';
import { DocsTable } from './DocsTable.esm.js';
import { actionFactories } from './actions.esm.js';
import { columnFactories } from './columns.esm.js';

const EntityListDocsTable = (props) => {
  var _a, _b;
  const { columns, actions, options } = props;
  const { loading, error, entities, filters } = useEntityList();
  const { isStarredEntity, toggleStarredEntity } = useStarredEntities();
  const [, copyToClipboard] = useCopyToClipboard();
  const title = capitalize((_b = (_a = filters.user) == null ? void 0 : _a.value) != null ? _b : "all");
  const defaultActions = [
    actionFactories.createCopyDocsUrlAction(copyToClipboard),
    actionFactories.createStarEntityAction(
      isStarredEntity,
      toggleStarredEntity
    )
  ];
  if (error) {
    return /* @__PURE__ */ React.createElement(
      WarningPanel,
      {
        severity: "error",
        title: "Could not load available documentation."
      },
      /* @__PURE__ */ React.createElement(CodeSnippet, { language: "text", text: error.toString() })
    );
  }
  return /* @__PURE__ */ React.createElement(
    DocsTable,
    {
      title,
      entities,
      loading,
      actions: actions || defaultActions,
      columns,
      options
    }
  );
};
EntityListDocsTable.columns = columnFactories;
EntityListDocsTable.actions = actionFactories;

export { EntityListDocsTable };
//# sourceMappingURL=EntityListDocsTable.esm.js.map
